<template>
  <div class="col col-md-6 pr-1">
    <PhotosModal/>
    <div class="docuvtabs">
      <div class="all-tabs float-left">
        <!--      Links Of All Tabs-->
        <all-tabs-links/>
      </div>

      <!--      All Tabs Content-->
      <div class="tab-content pr-0 pl-md-2 pl-3 pb-1 zero-index">
        <!--        All Tabs will be in separate components  -->
<!--        <TemplatesTab/>-->
<!--        <BasicThemeTab/>-->
<!--        <CoverPhotoTab/>-->
<!--         Images Tab-->
        <PhotosTab/>
        <text-page-tab/>
<!---->
<!--        <plans-page/>-->

      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import AllTabsLinks from './AllTabsLinks'
import PhotosTab from './PhotosTab'
import TextPageTab from './TextPageTab'
import PhotosModal from './PhotosModal'
export default {
  components: {
    PhotosModal,
    AllTabsLinks,
    PhotosTab,
    TextPageTab
  }
}

</script>
<style scoped>
.section-images:hover i{
  display: block !important;
  cursor: pointer !important;
}
.active{
  background: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/DetailsSideTabs.vue